import get from 'lodash/get'

export const selectHeightFadeTimers = state =>
  get(state, 'transitions.heightFadeTimers')
